<template>
    <div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "H5Layout",
        data() {
            return {}
        },
        components: {},
        watch: {},
        mounted() {

        },
        created() {
            // const script = document.createElement('script');
            // script.src = '/static/js/vendor/jquery-1.12.4.min.js';
            // script.onload = () => {
            //     // 文件加载完毕后的回调
            //     console.log('External JS file loaded!');
            // };
            // document.head.appendChild(script);
        },
        methods: {}
    }
</script>

<style scoped>

</style>
